import * as checkoutTypes from "@vue-storefront/core/modules/checkout/store/checkout/mutation-types";
import * as userTypes from "@vue-storefront/core/modules/user/store/mutation-types";
import * as userAddressTypes from "@vue-storefront/core/modules/user/store/address/mutation-types";
import * as orderTypes from '@vue-storefront/core/modules/order/store/mutation-types';
import * as cartTypes from "@vue-storefront/core/modules/cart/store/mutation-types";

import updateObject from "@vue-storefront/core/scripts/utils/update-object";
import { isServer } from "@vue-storefront/core/helpers";
import { hasProperties } from "@vue-storefront/core/helpers/workWithObjects";
import Vue from 'vue'

export default function saveToLocalStorage(store) {
  store.subscribe(async (mutation, state) => {
    switch (mutation.type) {
      // shipping
      case 'shipping/updateShippingDetailsState': {
        localStorage.setItem('shop/checkoutFieldValues/shipping-details-state', JSON.stringify(updateObject(state.shipping.shippingDetailsState, mutation.payload)));
        break;
      }
      // checkout
      case `checkout/${checkoutTypes.CHECKOUT_CLEAR_DETAILS}`: {
        localStorage.setItem('shop/checkoutFieldValues/personal-details', JSON.stringify(mutation.payload.personalDetails));
        localStorage.setItem('shop/checkoutFieldValues/shipping-details', JSON.stringify(mutation.payload.shippingDetails));
        localStorage.setItem('shop/checkoutFieldValues/payment-details', JSON.stringify(mutation.payload.paymentDetails));
        break;
      }
      case `checkout/${checkoutTypes.CHECKOUT_SAVE_ADDNEWADDRESS}`: {
        store.dispatch('shipping/updateShippingDetailsState', updateObject(state.shipping.shippingDetailsState, {
          saveToAddressBook: mutation.payload
        }));
        break;
      }
      // user
      case `user/${userTypes.USER_INFO_LOADED}`: {
        if (!isServer) {
          const user = mutation.payload;
          const guestAddressStorageData = localStorage.getItem('shop/user/guest-addresses');
          if (guestAddressStorageData) {
            const guestAddresses = JSON.parse(guestAddressStorageData);
            let guestAddress = null;

            if (Array.isArray(guestAddresses)) {
              guestAddress = guestAddresses[0];
            }

            const validAddress = hasProperties({
              object: guestAddress,
              properties: ['api_details', 'city', 'country', 'house', 'latitude', 'longitude', 'state', 'street'],
              allPropertiesIsRequired: true
            });

            const validUser = hasProperties({
              object: user,
              properties: ['id', 'firstname', 'lastname', 'telephone'],
              allPropertiesIsRequired: true
            })
            if (validAddress && validUser) {
              delete guestAddress.id;
              try {
                await store.dispatch('address/create', {
                  address: {
                    ...guestAddress,
                    customer_id: user.id,
                    firstname: user.firstname,
                    lastname: user.lastname,
                    phone_number: user.telephone,
                    default_shipping: true
                  }
                })
              } catch (err) {
                console.error(err);
              }
            }
          }

          if (user) {
            await store.dispatch('address/clearGuestState');
            localStorage.removeItem('shop/user/guest-addresses');
            await store.dispatch('address/loadList')
              .then(async (response) => {
                const defaultAddress = response.find(address => address.default_shipping)

                if (defaultAddress) {
                  await store.dispatch('checkout/saveShippingDetails', updateObject(state.checkout.shippingDetails, defaultAddress));
                }
              });
          }

          localStorage.setItem('shop/user/current-user', JSON.stringify(mutation.payload));
          await store.dispatch('cart/authorize')
          await store.dispatch('cart/load', { refreshTotals: !!guestAddressStorageData })
            .then(() => {
              Vue.prototype.$bus.$emit('user-after-loggedin-with-cart')
            })
        }
        break;
      }
      case `user/${userTypes.USER_END_SESSION}`: {
        if (!isServer) localStorage.removeItem('shop/order/last-placing-orders-data');
        break;
      }

      // user address
      case `address/${userAddressTypes.GUEST_ADDRESS_ADD}`:
      case `address/${userAddressTypes.GUEST_ADDRESS_UPDATE}`:
      case `address/${userAddressTypes.GUEST_ADDRESS_SET_DEFAULT}`: {
        if (!isServer) {
          localStorage.setItem('shop/user/guest-addresses', JSON.stringify(state.address.guest_addresses));
        }
        break;
      }
      case `address/${userAddressTypes.USER_ADDRESS_DELETE}`: {
        await store.dispatch('cart/load', { refreshTotals: true });
        break;
      }
      case `address/${userAddressTypes.GUEST_ADDRESS_DELETE}`: {
        if (!isServer) {
          localStorage.setItem('shop/user/guest-addresses', JSON.stringify(mutation.payload));
          localStorage.setItem('shop/checkoutFieldValues/shipping-details', JSON.stringify(mutation.payload.shippingDetails));
        }

        await store.dispatch('cart/load', { refreshTotals: true });
        break;
      }

      // cart
      case `cart/${cartTypes.CART_DEL_ITEM}`: {
        await store.dispatch('cart/load', { refreshTotals: true, isUpdate: true });
        break;
      }

      // order
      case `order/${orderTypes.ORDER_LAST_ORDER_WITH_CONFIRMATION}`: {
        if (!isServer) {
          const data = mutation.payload;
          if (data) {
            localStorage.setItem('shop/order/last-placing-orders-data', JSON.stringify(data.confirmation.orders));
          }
        }
        break;
      }
    }
  })
}
